import 'core-js/stable';
import 'regenerator-runtime/runtime';

// @ts-ignore
import * as errorToolTip from '../general/errorToolTip';
import '../vendor/jquery.cookie-1.4.1';
import '../general/sites_index';
import '../general/sites_common';
import '../general/modules/languageSelect';
import '../general/handlers/restoreFormHandler';
import { onReadyCalcBack } from '../general/calcIndexBackAndPopup';
import { JsFormResponseHandlerObject } from '../general/modules/jsFormTypes';
import { JRpcErrResponse } from '../general/modules/jsonRpc/jRpcErrResponse';
import { StretchPopup } from '../popups/stretchPopup';
import { GtmSender } from '../marketing/GtmSender';
import { SystemEvents } from '../constants/gameEvents';
import { CurrentEntryPoint } from '../constants/CurrentEntryPoint';
import { initCookieWarning } from '../general/modules/cookieWarning';
import { UserFingerprint } from '../general/modules/userFingerpint/UserFingerprint';
import { ClientJS } from 'clientjs';
import { UserSession } from '../general/modules/user/userSession';
import { Url } from '../general/modules/url';
import { MailingLogin } from '../login/mailing/MailingLogin';
import { BuildMailingUser } from '../login/mailing/BuildMailingUser';
import { initDelayedDeletionPopupHandler } from '../general/handlers/delayedDelitonPopupHandler';
import { initOtpForm } from '../general/handlers/otpFormHandler';
import { init2FaOtpForm } from '../general/handlers/otp2FaFormHandler';
import { initRegistrationFormHandler } from '../general/handlers/registrationFormHandler';
import '../general/modules/newPassword/newPasswordFormHandler';

const NEWPASS_RESPONSE_ERROR_CODES = {
    CONFIRM_EMPTY: 6,
    CONFIRM_FAIL: 7
};

function isSeoMainPage() {
    return window.app.config.current_entry_point === CurrentEntryPoint.SITE2 &&
        window.app.config.language === 'en';
}

function onDocumentReady() {
    setEventsTracking();
    new UserFingerprint(new ClientJS());
    if (CurrentEntryPoint.SITE === window.app.config.current_entry_point) {
        initCookieWarning();
    }
    window.app.newpass_form_handler = NewPassFormHandler;
    // @ts-ignore
    $('#expires').val($.urlParam('expires'));
    // @ts-ignore
    $('#email').val($.urlParam('email'));
    // @ts-ignore
    $('#token').val($.urlParam('token'));

    onReadyCalcBack();
    $('video').on('load loadedmetadata', () => {
        onReadyCalcBack();
    });

    if (isSeoMainPage()) {
        import(('../vendor/jquery.fancybox.min'));
    }

    initOtpForm();
    init2FaOtpForm();
    loginViaToken();
    initDelayedDeletionPopupHandler();
    initRegistrationFormHandler();
}

function NewPassFormHandler(data: JsFormResponseHandlerObject<NewpassFormResponse>) {
    const parent = data.form.parent();
    const response = data.response;

    if (response.error) {
        if (
            response.error.code === NEWPASS_RESPONSE_ERROR_CODES.CONFIRM_EMPTY ||
            response.error.code === NEWPASS_RESPONSE_ERROR_CODES.CONFIRM_FAIL
        ) {
            errorToolTip(
                $('input[name=new-password]', parent),
                0,
                response.error.message
            );
        } else {
            errorToolTip(
                $('input[name=current-password]', parent),
                0,
                response.error.message
            );
        }
        return;
    }

    const $responseB = $('.js-response', parent);
    const $resetElements = $('.js-close-button, .js-response input', parent);

    data.form.hide();
    $responseB.show();

    $resetElements.on('click.restoreReset', function handleRestoreFromClose() {
        data.form.show();
        $responseB.hide();
        $resetElements.off('click.restoreReset');
    });
    StretchPopup.stretch();
}

function loginViaToken(): void {
    const session = UserSession.getInstance();
    const url = Url.current();
    const buildMailingUser = new BuildMailingUser(window.app.config, url, session);
    const mailingUser = buildMailingUser.build();
    if (mailingUser) {
        console.log('trying to authorize mailing user');
        const login = new MailingLogin(mailingUser);
        login.auth();
    }
}

function setEventsTracking() {
    $('#registration input[name=email], #registration2 input[name=email]')
        .one('keypress', function handleRegEmailInputKeypress() {
            $('#registration input[name=email], #registration2 input[name=email]')
                .one('change', function handleRegEmailInputChange() {
                    GtmSender.fireIndex(SystemEvents.ENTER_EMAIL);
                });
        });

    $('#registration input[name=password], #registration2 input[name=password]')
        .one('keypress', function handleRegPasswordInputKeypress() {
            $('#registration input[name=password], #registration2 input[name=password]')
                .one('change', function handleRegPasswordInputChange() {
                    GtmSender.fireIndex(SystemEvents.ENTER_PASSWORD);
                });
        });

    $('#login, #registration').find('.icon')
        .one('click', function handleSocialIconClick() {
            GtmSender.fireIndex(SystemEvents.CLICK_SOCIAL_ICON);
        });

    $('#registration .js-terms_agree,#registration2 .js-terms_agree').one('click', () => {
        GtmSender.fireIndex(SystemEvents.CHECK_POLICY);
    });

    const consentCheckboxSelectors = [
        '#registration #receive_consent',
        '#registration2 .registration_dialog_terms__agree',
        '#registration #receive_consent0',
        '#registration #receive_consent1'
    ];
    $(consentCheckboxSelectors.join(', ')).one('click', () => {
        GtmSender.fireIndex(SystemEvents.CHECK_CONSENT);
    });

    $(document).one(
        'click',
        '#registration:not(.step1) [type="submit"],#registration2:not(.step1) [type="submit"]', () => {
            GtmSender.fireIndex(SystemEvents.SUBMIT);
        }
    );
}

type NewpassFormResponse = {} & JRpcErrResponse;

$(onDocumentReady);
